<div class="banner d-none d-lg-flex" role="banner">
  <div class="container">
    <div class="title-wrapper">
      <img src="assets/images/banners/Terms.png" alt="" />
    </div>
  </div>
</div>
<fgb-mobile-header-bar [title]="'terms.page.title' | translate" [showPoints]="false"></fgb-mobile-header-bar>

<div class="mobile-content-wrapper">
  <div class="container">
    <div class="card">
      <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">
    <fgbcl-loading></fgbcl-loading>
  </p>
</ng-template>
